import {
    EMAIL_INVALID,
    EMAIL_REQUIRED,
    LOGIN_INVALID,
    PASSWORD_CONFIRM_MISMATCH,
    PASSWORD_INVALID,
    REGISTER_EMAIL_EXISTS,
    REGISTER_USERNAME_NOT_AVAILABLE,
    SERVER_ERROR,
    USERNAME_NO_SYMBOLS,
    USERNAME_TOO_LONG,
    USERNAME_TOO_SHORT,
} from "../constants";

export default {
    [LOGIN_INVALID]: "The username/password you provided is incorrect.",
    [SERVER_ERROR]: "A server error has occurred.",
    [EMAIL_INVALID]: "The email address must be valid.",
    [EMAIL_REQUIRED]: "You must provide an email address.",
    [PASSWORD_CONFIRM_MISMATCH]: "The password and confirmation password must match.",
    [PASSWORD_INVALID]: "Your password must be at least {{ minLength }} characters long and contain at least one " +
        "letter and one number.",

    [USERNAME_TOO_SHORT]: "Your username must be at least {{ minLength }} characters long.",
    [USERNAME_TOO_LONG]: "Your username can be {{ maxLength }} characters long at most.",
    [USERNAME_NO_SYMBOLS]: "Your username may not contain special symbols.",
    [REGISTER_EMAIL_EXISTS]: "The email address is already in use.",
    [REGISTER_USERNAME_NOT_AVAILABLE]: "The username is already in use.",

    SERVER_ERROR_MODAL: {
        MESSAGE: "A server error has occurred.  Please refresh your browser.",
        TITLE: "Server Error",
    },

    LOGIN_REQUIRED_MODAL: {
        MESSAGE: "You must register or log in to be able to purchase tickets.",
        TITLE: "Not Logged In",
    },

    TRANSACTION_LABELS: {
        purchase_ticket: "Ticket Purchase",
    },

    CLOSE: "Close",
    OK: "OK",
};



// WEBPACK FOOTER //
// ./src/locales/EN_US.ts